import React from 'react';
import styled from 'react-emotion';
import t from '@jetshop/intl';

const ProductRange = styled.span`
  color: red;
`;

const TotalProducts = styled.span``;

const PaginationInfo = styled.span`
  color: black;
  text-transform: uppercase;
  font-size: 12px;
`;

export default ({ offset, perPage, currentPage, totalItems }) => {
  return (
    <PaginationInfo>
      {t('Showing')}
      <ProductRange>
        {' '}
        {offset + 1}-{perPage * currentPage}
      </ProductRange>
      <TotalProducts> ({totalItems})</TotalProducts>
    </PaginationInfo>
  );
};
